import { render, staticRenderFns } from "./syssetting.vue?vue&type=template&id=29fdc09e&scoped=true"
import script from "./syssetting.vue?vue&type=script&lang=js"
export * from "./syssetting.vue?vue&type=script&lang=js"
import style0 from "./syssetting.vue?vue&type=style&index=0&id=29fdc09e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fdc09e",
  null
  
)

export default component.exports